// client/src/components/Layout.jsx
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen">
            {/* Full-width Navbar */}
            <Navbar />

            {/* Main Content */}
            <main className="flex-grow">
                <div className="max-w-screen-xl mx-auto px-4">{children}</div>
            </main>

            {/* Full-width Footer */}
            <Footer />
        </div>
    );
};

export default Layout;
